module.exports = __webpack_public_path__ + "static/media/03.79e19ed4.jpg";